module.exports = "//static.hsappstatic.net/salesImages/static-1.403/onboarding/hubspot-demo-thumb.png"